export const VERSION_CWA = 'v 1.0.23';
export const VERSION_CWA_NUMBER = '1.0.23';
